<template>
  <div class="appointments-header container mx-auto text-center md:text-left mb-4">
    <div class="w-full xl:w-3/5 float-left xl:pr-10">
      <h1 class="page-title">{{ pageTitle }}</h1>
      <p class="pb-6 text-xl text-gray-darker" v-html="copy"></p>
      <div class="price-card text-center md:float-left py-5 px-16 md:mr-6 mb-6">
        <div class="text-base">Pay as you go price</div>
        <template v-if="loadingPrices">
          <div class="bg-gray-200">
            <div class="skeleton-price bg-gray-300 h-12 w-1/2 mx-auto rounded-lg"></div>
          </div>
        </template>
        <template v-else>
          <div class="text-3xl" >{{ price }}</div>
        </template>
      </div>
      <div class="info-items md:float-left md:ml-6 text-left">
        <div v-for="(item, index) in items" :key="index" class="pb-6">
          <img :src="getIconUrl(item.icon)" alt="" class="float-left pt-2" />
          <p v-html="item.text" class="pl-8 text-gray-darker text-base"></p>
        </div>
      </div>
    </div>

    <div class="xl:block xl:w-2/5 md:w-4/5 float-right xl:pl-10">
      <div class="cta bg-white py-5 px-10 text-center">
        <h2 class="page-title pb-2">{{ switchBlockTitle }}</h2>
        <p class="text-blue pb-6">{{ switchBlockContent }}</p>
        <a :href="switchBlockLink" class="btn btn-primary mx-auto">{{ switchBlockLabel }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { Prices } from "@/lib/Prices";
import store from "@/store";
export default {
  name: 'video-appointments-header',
  props: ['pageTitle', 'copy', 'items', 'switchBlockLink', 'switchBlockLabel', 'switchBlockTitle', 'switchBlockContent'],

  computed: {
    price() {
      if (this.$route.path === '/video') {
        return Prices.video().toLocaleString('en-GB', {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      }

      const lowest = Prices.outsideM25().toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      const highest = (Prices.hasExceptionPrice() ? Prices.exception() : Prices.insideM25()).toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return lowest + ' - ' + highest;
    },
    priceLowest() {
      return Prices.outsideM25();
    },

    priceHighest() {
      return Prices.hasExceptionPrice() ? Prices.exception() : Prices.insideM25();
    },
    loadingPrices() {
      return store.getters['rates/getLoadingPrices']
    },
  },
  methods: {
    getIconUrl(icon) {
      const images = require.context('../../assets/images/', false, /\.svg$/);
      return images('./' + icon + ".svg");
    }
  }
}
</script>

<style lang="scss" scoped>
.appointments-header {
  @apply px-4 mx-auto w-full;
}

.price-card {
  background: white;
  border-radius: 10px;
}

.info-items {
  @media (min-width: 768px) {
    max-width: 48%;
  }
}

.cta {
  border-radius: 10px;

  h2 {
    font-size:  30px;
    line-height: 35px;
  }

  p {
    font-size: 20px;
    line-height: 25px;
  }

  a {
    max-width: 300px;
  }
}
</style>